console.log("Run functions!")

/*
document.addEventListener('click', function (e) {
  const btn2 = e.target.closest('.iEweFJJcHrBrajvmI');
  if (!btn2) return;

  if (!window.location.pathname.includes('/products/droff-1')) return;

  const target = document.querySelector('.custom-popup-container');
  if (target) target.classList.add('active');
});
*/

document.addEventListener('click', function (e) {
  const btn2 = e.target.closest('.iNpLyvoCLUIj3zBrh');
  if (!btn2) return;

  if (!window.location.pathname.includes('/products/droff-1')) return;

  // Si el plan activo es suscripción -> redirige a la URL del metafield
  if (window.__subPlan === 'plan') {
    e.preventDefault();
    e.stopPropagation();

    const span = document.querySelector('.custom-link-sub > span');
    const url = span ? span.textContent.trim() : '';
    if (url) {
      window.location.href = url;
      return;
    }
    // Si no hay URL, no abras el popup en modo suscripción; simplemente sal
    return;
  }

  // Modo compra única -> comportamiento actual: abrir el popup
  const target = document.querySelector('.custom-popup-container');
  if (target) target.classList.add('active');
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-modal-close');
  if (!btn) return;

  const target = document.querySelector('.custom-popup-container');
  if (target) target.classList.remove('active');

  document.querySelector('body').classList.remove('product-droff-1')
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-modal-close-adding');
  if (!btn) return;


  setTimeout(() => {
    const realATC = document.querySelector('.custom-info-pdp .custom-pdp-atc');
    if (realATC) {
      realATC.click()
    }
  }, 500);

  document.querySelector('body').classList.remove('product-droff-1')
});


(function () {
  document.querySelector('body').classList.remove('product-droff-1')
  
  if (!window.location.pathname.includes('products/droff-1')) {
    document.querySelectorAll('.custom-info-pdp').forEach(function (el) {
      el.classList.add('normal-product');
    });
  }

  const atcAtc = document.querySelector('.custom-modal-atc')
  if (atcAtc) {
    atcAtc.addEventListener('click', function (e) {
      const target = document.querySelector('.custom-popup-container');
      if (target) target.classList.remove('active');

      const realATC = document.querySelector('.custom-pdp-atc');
      if (realATC) {
        realATC.click()
      }

      document.querySelector('body').classList.remove('product-droff-1')
    });
  }

})();


document.querySelectorAll('.custom-text-colors p').forEach((p) => {
  if (p.dataset.colorized) return;
  p.dataset.colorized = 'true';

  const text = p.textContent.trim();
  const frases = text.match(/[^.]+\.?/g) || [];

  p.innerHTML = frases
    .map((frase, i) => {
      const esUltima = i === frases.length - 1;
      const color = esUltima ? '#1773ff' : 'inherit';
      return `<mark style="color: ${color}">${frase}</mark>`;
    })
    .join('');
});

(function () {
  'use strict';
  console.log("Run sticky atc")
  function initStickyATC() {
    const atc = document.querySelector('.custom-pdp-atc');
    const sticky = document.querySelector('.custom-sticky-atc');

    if (!atc || !sticky) return;

    console.log("atc", atc)
    console.log("sticky", sticky)

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // El botón principal SÍ se ve -> ocultar sticky
            sticky.classList.remove('visible');
          } else {
            // El botón principal NO se ve -> mostrar sticky
            sticky.classList.add('visible');
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // dispara apenas asoma/desaparece 1px
      }
    );

    observer.observe(atc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();

document.addEventListener('click', function(e) {
  const link = e.target.closest('.custom-link-faqs');
  if (!link) return;
  e.preventDefault();

  const target = document.querySelector('div.custom-section-faqs');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

document.addEventListener('click', function(e) {
  const link = e.target.closest('.custom-link-complete');
  if (!link) return;
  e.preventDefault();

  const target = document.querySelector('div.custom-section-complete');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

document.addEventListener('click', function(e) {
  const link = e.target.closest('.custom-link-works');
  if (!link) return;
  e.preventDefault();

  const target = document.querySelector('div.custom-section-works');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

document.addEventListener('click', function(e) {
  const link = e.target.closest('.custom-link-rms');
  if (!link) return;
  e.preventDefault();

  const target = document.querySelector('div.custom-section-rms');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

function syncProgressBars() {
  console.log("Run bar functions")
  document.querySelectorAll('[class*="custom-bar-percent-"]').forEach(function (percentEl) {
    const match = percentEl.className.match(/custom-bar-percent-(\d+)/);
    if (!match) return;

    const index = match[1];
    const bar = document.querySelector('.custom-bar-progress-' + index);
    if (!bar) return;

    // Lee el porcentaje del texto (ej: "94%")
    const value = parseFloat(percentEl.textContent);
    if (isNaN(value)) return;

    bar.style.width = value + '%';
  });
}

document.addEventListener('DOMContentLoaded', syncProgressBars);


/* custom subs */
var RANDOM_URL = 'https://example.com'; // TODO: reemplazar por la URL real

function bindAtcRedirect() {
  var atc = document.querySelector('.iEweFJJcHrBrajvmI, .iEweFJJcHrBrajvmI-plan');
  if (!atc || atc.dataset.planRedirectBound) return;

  atc.dataset.planRedirectBound = 'true';
  atc.addEventListener('click', function (e) {
    // Solo redirige si en este momento está en modo "-plan"
    if (atc.classList.contains('iEweFJJcHrBrajvmI-plan')) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = RANDOM_URL;
    }
  }, true); // captura: corre antes que el handler de Instant
}


(function () {
  var currentPlan = 'one'; // 'plan' | 'one'
  var applyScheduled = false;

  function getSubUrl() {
    var span = document.querySelector('.custom-link-sub > span');
    if (!span) return '';
    return span.textContent.trim();
  }

  function updatePdpPrice(sourceSelector) {
    if (!window.location.pathname.includes('products/droff-1')) return;
    var source = document.querySelector(sourceSelector);
    if (!source) return;
    var priceText = source.textContent.trim();
    document.querySelectorAll('.custom-pdp-price').forEach(function (el) {
      if (el.textContent.trim() !== priceText) {
        el.textContent = priceText;
      }
    });
  }

  function applyAtcClass() {
    if (!window.location.pathname.includes('products/droff-1')) return;
    var atc = document.querySelector('.iEweFJJcHrBrajvmI, .iEweFJJcHrBrajvmI-plan');
    if (!atc) return;

    if (currentPlan === 'plan') {
      if (atc.classList.contains('iEweFJJcHrBrajvmI')) {
        atc.classList.remove('iEweFJJcHrBrajvmI');
        atc.classList.add('iEweFJJcHrBrajvmI-plan');
      }
    } else {
      if (atc.classList.contains('iEweFJJcHrBrajvmI-plan')) {
        atc.classList.remove('iEweFJJcHrBrajvmI-plan');
        atc.classList.add('iEweFJJcHrBrajvmI');
      }
    }
  }


  function applyState() {
    var planCard = document.querySelector('.custom-card-sub-plan');
    var oneCard  = document.querySelector('.custom-card-sub-one');
    if (!planCard || !oneCard) return;

    planCard.classList.toggle('active', currentPlan === 'plan');
    oneCard.classList.toggle('active', currentPlan === 'one');

    var qtySelector = document.querySelector('.custom-qty-selector');
    if (qtySelector) {
      qtySelector.classList.toggle('active', currentPlan === 'one');
    }

    var upsellSelector = document.querySelector('.custom-upsell-selector');
    if (upsellSelector) {
      upsellSelector.classList.toggle('active', currentPlan === 'one');
    }

    updatePdpPrice(currentPlan === 'plan' ? '.custom-plan-price' : '.custom-normal-price');

    applyAtcClass();
    window.__subPlan = currentPlan;
  }

  function scheduleApply() {
    if (applyScheduled) return;
    applyScheduled = true;
    requestAnimationFrame(function () {
      applyScheduled = false;
      applyState();
    });
  }

  function bindAtcRedirect() {
    // El botón de suscripción es el div .custom-pdp-atc-subs
    var atcSubs = document.querySelector('.custom-pdp-atc-subs');
    if (!atcSubs || atcSubs.dataset.subsRedirectBound) return;

    atcSubs.dataset.subsRedirectBound = 'true';
    atcSubs.style.cursor = 'pointer';
    atcSubs.addEventListener('click', function () {
      // Solo redirige si estamos en modo suscripción
      if (currentPlan !== 'plan') return;
      var url = getSubUrl();
      if (url) {
        window.location.href = url;
      }
    });
  }

  function bindCards() {
    var planCard = document.querySelector('.custom-card-sub-plan');
    var oneCard  = document.querySelector('.custom-card-sub-one');
    if (!planCard || !oneCard) return false;

    [[planCard, 'plan'], [oneCard, 'one']].forEach(function (pair) {
      var card = pair[0], key = pair[1];
      if (!card.dataset.subPlanBound) {
        card.dataset.subPlanBound = 'true';
        card.style.cursor = 'pointer';
        card.addEventListener('click', function () {
          currentPlan = key;
          applyState();
        });
      }
    });

    bindAtcRedirect();
    applyState();
    return true;
  }

  var observer = new MutationObserver(function () {
    bindCards();
    scheduleApply();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  bindCards();
})();

(function () {
  function getActiveTargetButton() {
    var sticky = document.querySelector('.custom-pdp-atc-sticky');
    var main = document.querySelector('.custom-pdp-atc');

    // Prioriza el sticky si está visible (clase .visible + no display:none)
    if (sticky && sticky.classList.contains('visible') && getComputedStyle(sticky).display !== 'none') {
      return sticky;
    }
    if (main && getComputedStyle(main).display !== 'none') {
      return main;
    }
    return null;
  }

  function positionEasySellOverlay() {
    var esButton = document.querySelector('#es-popup-button');
    var target = getActiveTargetButton();

    if (!esButton || !target) {
      if (esButton) esButton.style.display = 'none';
      return;
    }

    var rect = target.getBoundingClientRect();

    esButton.style.display = 'block';
    esButton.style.top = rect.top + 'px';
    esButton.style.left = rect.left + 'px';
    esButton.style.width = rect.width + 'px';
    esButton.style.height = rect.height + 'px';
  }

  window.addEventListener('scroll', positionEasySellOverlay, { passive: true });
  window.addEventListener('resize', positionEasySellOverlay);

  var ro = new ResizeObserver(positionEasySellOverlay);
  document.querySelectorAll('.custom-pdp-atc, .custom-pdp-atc-sticky').forEach(function (el) {
    ro.observe(el);
  });

  var mo = new MutationObserver(positionEasySellOverlay);
  mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });

  positionEasySellOverlay();
  setTimeout(positionEasySellOverlay, 500); // por si el layout tarda en asentarse
})();